// Patient populations the formulary filters offer.
//
// A FIXED SET, not reference data: there are two, they are the same for every
// tenant, and nothing serves them. So this is a real constant rather than a
// fixture — it does not disappear when the placeholder endpoints do.
//
// `network_limit_patient_population` is NOT this. It is the only autocomplete
// subject whose name mentions populations, but it belongs to the network-limits
// domain (it drives the Safety limits filters) and has been determined to be a
// different concept that shares a word — not a differently-tenanted version of
// this list. Do not wire it in.
//
// If a real source for THIS list ever exists, the swap is confined to
// ReferenceService.getPatientPopulations: it is already an async method whose
// result the store reads positionally, so no store or component code changes.
// See DISCOVER_DATA_CONTRACTS.md §2.
//
// Uppercase to match `ALL_MEDICATIONS` and the casing the chart pipeline
// assumes for filter values.
export const PATIENT_POPULATIONS = ['ADULT', 'PEDIATRIC'];

export default PATIENT_POPULATIONS;
